import internalStateService from "../app/InternalStateService";
import typeOfOperand from "@tinqin/tinqin-utils/src/base/typeOfOperand";
import ArrayUtils from "@tinqin/tinqin-utils/src/array";
import { WEBUILogs } from "@tinqin/tinqin-utils/src/logging";

//SIREN Actions
//Default structure:
// {
//     //type of action to be triggered
//     "actionType": "update",
//     //event on which the action to be triggered
//     //(default: undefined, action will be triggered on the default event for the source component)
//     "event": "click",
//     //action specific use
//     "dependencies": [],
//     "failActions": [],
//     "successActions": [],
//     "finalActions": [],
//     "actions": [ {actionType: "", event || events: ["success", "failure", "final"]}]
// }
function filterActions(actions = [], sourceEvent = ["default"]) {
    let filteredActions = actions.filter(action => {
        let actionEvents = ["default"];
        let events = action.event || action.events;
        if (events) {
            if (typeOfOperand(events) === "string") {
                actionEvents = [events];
            } else if (typeOfOperand(events) === "array") {
                actionEvents = events;
            }
        }

        return ArrayUtils.includesAtLeastOneOf(actionEvents, sourceEvent);
    });
    //cloning actions to prevent shared memory issues for actions that modify actions object
    //For example: loadingAnimation action
    return Array.from(filteredActions);
}
export function dispatchSirenAction(action = {}, ...actionProps) {
    //cloning actions to prevent shared memory issues for actions that modify actions object
    //For example: loadingAnimation action
    let clonedAction = JSON.parse(JSON.stringify(action));
    return dispatchAction(clonedAction, ...actionProps);
}

export function dispatchSirenActions(
    actions = [],
    sourceWidget,
    sourceEntity,
    sourceEvent,
    options = {}
) {
    //filtering actions, triggering only those that match the sourceEvent
    //BE can provide event as string or array of strings, we check if source event matches any.
    let filteredActions = filterActions(actions, sourceEvent);

    filteredActions = Array.from(filteredActions);
    if (sourceEvent !== "load" && filteredActions.length)
    // "%cActions:%c   %cWidget: %s%c   %cEntity: %s%c   %cAction event: %s%c   %cSiren Actions: %c%o",
    // "color: yellow; font-weight: bold; background-color:#5abb45;padding: 5px;font-size:0.8em;",
    // "",
    // "",
    // sourceWidget,
    // "",
    // "",
    // sourceEntity,
    // "",
    // "",
    // (sourceEvent && sourceEvent.toString()) || "default",
    // "",
    // "",
    // "",
    // filteredActions
        WEBUILogs.log(
            "%cActions:%c   %cWidget: %s%c   %cEntity: %s%c   %cAction event: %s%c   %cSiren Actions: %c%o",
            "color: yellow; font-weight: bold; background-color:#5abb45;padding: 5px;font-size:0.8em;",
            "",
            "",
            sourceWidget,
            "",
            "",
            sourceEntity,
            "",
            "",
            (sourceEvent && sourceEvent.toString()) || "default",
            "",
            "",
            "",
            filteredActions
        );

    if (options.returnPromise) {
        return dispatchActions(filteredActions, sourceWidget, sourceEntity, sourceEvent);
    }
    return dispatch => {
        let actionResult = dispatch(
            dispatchActions(filteredActions, sourceWidget, sourceEntity, sourceEvent)
        );
        //catching any errors to prevent default console.error messages
        return actionResult.catch(error => {
            if(error?.message !== undefined && !error.message.startsWith("<silent>:")){
                WEBUILogs.warn(error);
            }
        });
    };
}

function dispatchActions(actions, ...actionProps) {
    return dispatch =>
        Promise.all(actions.map(action => dispatch(dispatchAction(action, ...actionProps))));
}

function dispatchAction(action = {}, ...actionProps) {
    return async dispatch => {
        let actionToDispatch;
        let actionResult;

        actionToDispatch = internalStateService.getSirenAction([action.actionType], {
            widgetId: actionProps[0]
        });

        if (!actionToDispatch) {
            WEBUILogs.error("Uknown actionType: " + action.actionType);
            return Promise.reject("Promise: uknown actionType: " + action.actionType);
        }

        WEBUILogs.log("Executing action: " + action.actionType);
        //as a side effect action object can be changed
        //(Example: showLoading action adding new finalAction for hiding loading animation after any nested actions are finished)
        actionResult = Promise.resolve(dispatch(actionToDispatch(action, ...actionProps)));
        try {
            await actionResult;
            //In case of success return the result of inner successActions
            let filterSuccessActions = filterActions(action.actions, ["success", "default"]);
            let filterFinalActions = filterActions(action.actions, ["final"]);
            let successActions = action.successActions || filterSuccessActions;
            let finalActions = action.finalActions || filterFinalActions;
            return dispatch(
                dispatchInnerActions(actionResult, successActions, finalActions, ...actionProps)
            );
        } catch (error) {
            //waiting for inner actions to finish before returning
            let failedActionsResult;
            let filterFailedActions = filterActions(action.actions, ["failure"]);
            let failActions = action.failActions || filterFailedActions;
            try {
                failedActionsResult = await dispatch(
                    dispatchInnerActions(
                        actionResult,
                        failActions,
                        action.finalActions,
                        ...actionProps
                    )
                );
            } catch (error) {
                failedActionsResult = error;
            }
            //In case of error, return rejected Promise with the result of failedActions
            //Promise.reject does not wait for inner Promise to complete
            return Promise.reject(failedActionsResult);
        }
    };
}

function dispatchInnerActions(actionResult, innerActions = [], finalActions = [], ...actionProps) {
    return async dispatch => {
        //returning result from the dispatched action in case there are no inner actions
        let result = actionResult;
        try {
            //executing inner actions if any
            if (innerActions.length) {
                result = await dispatch(dispatchActions(innerActions, ...actionProps));
            }
        } finally {
            //executing final actions if any after success/fail actions are finished
            if (finalActions.length) {
                dispatch(dispatchActions(finalActions, ...actionProps));
            }
        }
        return result;
    };
}
